import { transformLocalizedProductDetails } from '../../utils/transformLocalizedProductDetails';
import { CentralProductDetails } from '../CentralProductSidePanel/CentralProductDetails';
import type { LocalProductSidePanelProps } from './types';

type LocalProductGeneralProps = LocalProductSidePanelProps<'details'> & {
    productKey: string;
};

export const LocalProductGeneral = (props: LocalProductGeneralProps) => {
    const localizedData = transformLocalizedProductDetails(props);

    return (
        <CentralProductDetails
            id={props.enterpriseProductId}
            lockedFields
            hasLanguagesSelect
            localizedData={localizedData}
            {...props}
        />
    );
};
